import api from './index';

export const getLabels = async () => {
  try {
    const { data } = await api.get('/labels');
    return data;
  } catch (error) {
    throw error;
  }
};

export const getLabelByTask = async (taskId) => {
  try {
    const { data } = await api.get(`/task/${taskId}/labels`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const createTaskLabel = async (taskId, labelId, isSendWhats) => {
  try {
    const { data } = await api.post(`/task/${taskId}/label/${labelId}`, isSendWhats);
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteTaskLabel = async (taskId, labelId) => {
  try {
    const { data } = await api.delete(`/task/${taskId}/label/${labelId}`);
    return data;
  } catch (error) {
    throw error;
  }
};
